import React from 'react';
import { Box, Heading, Text, VStack } from '@chakra-ui/react';
interface SectionHeadingProps {
  eyebrow?: string;
  title: string;
  description?: string;
  tone?: 'light' | 'dark';
  align?: 'center' | 'left';
}
export function SectionHeading({
  eyebrow,
  title,
  description,
  tone = 'light',
  align = 'center'
}: SectionHeadingProps) {
  const isDark = tone === 'dark';
  return <VStack spacing={4} textAlign={align} align={align === 'center' ? 'center' : 'flex-start'} maxW="48rem" mx={align === 'center' ? 'auto' : 0} data-id="element-146" data-mp="bkn8h9igpzq2">
      {eyebrow && <Text fontSize="xs" fontWeight={700} letterSpacing="0.3em" textTransform="uppercase" color={isDark ? 'gold.400' : 'crimson.500'} data-id="element-147" data-mp="1v3m3tvjjnqg">
          {eyebrow}
        </Text>}
      <Heading as="h2" fontSize={{
      base: '2rem',
      md: '3.1rem'
    }} color={isDark ? 'cream.50' : 'crimson.500'} textTransform="uppercase" letterSpacing="-0.01em" data-id="element-148" data-mp="uhoe8wjuc3v2">
        {title}
      </Heading>
      <Box w="5rem" h="3px" bg="gold.400" alignSelf={align === 'center' ? 'center' : 'flex-start'} data-id="element-149" data-mp="1oaw4f2uzvopa" />
      {description && <Text fontSize={{
      base: 'md',
      md: 'lg'
    }} color={isDark ? 'cream.200' : 'ink.700'} opacity={isDark ? 0.9 : 0.85} data-id="element-150" data-mp="2300mmk1shsxe">
          {description}
        </Text>}
    </VStack>;
}